import XCalendar from "./index.vue";

export default XCalendar;
